function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      display: inline-block;\n      perspective: 1000px;\n      backface-visibility: hidden;\n      transform: translate3d(0, 0, 0);\n      animation: ",
        " 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  text-shadow: 0 2px white;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  display: inline-block;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 3em;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 0.8em;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  font-style: italic;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 600;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  display: inline-block;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
import styled, { css } from "styled-components";
export var MutedText = styled.span(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.components.text.muted.color;
});
export var ErrorText = styled.span(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.palette.error;
}, function(param) {
    var shake = param.shake;
    return shake && css(_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.animations.shakeAnimation;
    });
});
export var EngravedText = styled.span(_templateObject3());
export var CenteredText = styled.span(_templateObject4());
export var LargeText = styled.span(_templateObject5());
export var PrimaryText = styled.span(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.palette.primary;
});
export var SecondaryText = styled.span(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.palette.secondary;
});
export var MediumText = styled.span(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.font.mediumFontSize;
});
export var SmallText = styled.span(_templateObject9());
export var ItalicText = styled.span(_templateObject10());
export var BoldText = styled.span(_templateObject11());
export var SpacedText = styled.span(_templateObject12(), function(param) {
    var bottom = param.bottom;
    return bottom && "margin-bottom: 1rem;";
}, function(param) {
    var top = param.top;
    return top && "margin-top: 1rem;";
});
export var WarningText = styled.span(_templateObject13(), function(param) {
    var theme = param.theme;
    return theme.palette.warning;
});
export var SuccessText = styled.span(_templateObject14(), function(param) {
    var theme = param.theme;
    return theme.palette.success;
});
